import { useState, useMemo, useEffect } from 'react';

export const usePagination = ({ data, itemsPerPage, initialPage = 1, setPaginatedData }) => {
    const [currentPage, setCurrentPage] = useState(initialPage);

    const totalPages = useMemo(() => {
        return Math.ceil(data.length / itemsPerPage);
    }, [data, itemsPerPage]);

    const currentSlice = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        const end = currentPage * itemsPerPage;
        return { start, end };
    }, [currentPage, itemsPerPage]);

    const paginatedData = useMemo(() => {
        return data.slice(currentSlice.start, currentSlice.end);
    }, [data, currentSlice]);

    useEffect(() => {
        try {
            setPaginatedData(paginatedData);
        } catch (error) {
            console.error('Pagination error:', error);
        }
    }, [paginatedData, setPaginatedData]);

    return {
        currentPage,
        totalPages,
        setCurrentPage,
        paginatedData,
    };
};
